import Configuration from '@/agilis/util/Configuration'
import toursMixin from '@/agilis/components/Tour/mixins/toursMixin'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AppSelectorMixin',
  mixins: [toursMixin],

  components: {
    UnStyledLink
  },

  data: () => ({
    openSheet: false,
    applicationID: null
  }),

  computed: {
    ...mapGetters({
      authorizedApplications: 'configurationStore/auth/applications'
    })
  },

  methods: {
    openList (applicationId) {
      const workspaces = Object.values(this.authorizedWorkspaces(applicationId))
      this.applicationID = applicationId
      if (workspaces.length === 1) {
        this.$router.agilis.workspace(applicationId, workspaces[0].id)
      } else {
        this.openSheet = !this.openSheet
      }
    },

    authorizedWorkspaces (applicationId) {
      return Configuration.auth.getNestedWorkspaces(
        applicationId !== undefined ? applicationId : this.applicationID, this.authorizedApplications[applicationId].workspaces, {})
    },

    appIsLinkable (applicationId) {
      return Configuration.getApplicationTabs(applicationId).length > 0
    },

    appLink (applicationId) {
      return this.appIsLinkable(applicationId) ? this.$router.agilis.urlApp(applicationId) : null
    },

    appSettingsLink (applicationId) {
      return this.appIsLinkable(applicationId) ? this.$router.agilis.urlAppTab(applicationId, 'setting') : null
    },

    userCanAccessSettings (applicationId) {
      return Configuration.auth.userCanAccessSettings(applicationId)
    }
  }
}
